import React, {
  useEffect,
  useState,
  useCallback,
  useRef,
  useLayoutEffect,
} from "react";
import "./style.css";
import RelationShipChat from "./RelationShipChatScreen/RelationShipChat";
import {
  chatArisApi,
  chatArisApiRelationShip,
  chatElementsAssessmentApi,
  createMsg,
  getChatHistory,
  getLatestChatHistory,
  initiateChatSession,
  onChatEnd,
  openDialogueSession,
  parseStreamingResponse,
  rememberActivationSession,
  clearActivationSessionId,
} from "../../Services/Chat";
import {
  convertMessages,
  convertToNewFormat,
} from "../../Utils/CommonFunctions/chats";
import { useHeader } from "../../Providers/HeaderContextProvider";
import RelationshipHeader from "./RelationshipHeader";
import Cookies from "js-cookie";
import { useNavigate, useSearchParams, useLocation } from "react-router-dom";
import { startDialogue, getDialogueHistory } from "../../Services/dialogues";
import { toDialogueChatMessages } from "./dialogueMessages";
import { pauseCheckIn } from "../../Services/checkin";
import { trackEvent } from "../../Services/amplitude";
import { MISSION_EVENT, missionRoutes } from "../Journey/Mission/evolution";
import {
  recallEvolutionChat,
  rememberEvolutionChat,
} from "../Journey/Mission/evolutionChat";
import { showSuccessToast } from "../../Utils/toast";
import SessionSelection from "./LiveSession/SessionSelection";
import { Tooltip } from "react-tooltip";
import { ReactComponent as CheckGreen } from "../../Assets/icon/check-green.svg";
import {
  fetchInsightContent,
  getRelationshipAdvice,
  getRelationshipProfile,
} from "../../Services/Realtionship";
import { chatCreateRelationShip } from "../../Services/arisAI";
import { fetchElementsIntroConfig } from "../../Services/contentConfig";
import AddRelationShipChatModal from "./AddRelationShipChatModal";
import { getSessions } from "../../Services/coaching";
import DefaultLoader from "../LoadingPage/DefaultLoader";
import useActivationCompletion from "../../Hooks/useActivationCompletion";

function ChatInterface() {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const adviceTitle = searchParams?.get("adviceTitle");
  const relationId = searchParams?.get("relationId");

  const { setHeaderContent, screenWidth, headerContent, profileContent } = useHeader();

  // Activation: the send path picks the ACTIVATION module itself (Services/Chat),
  // this watches for the conversation finishing and unlocks the app.
  const { onConversationEnd: onActivationConversationEnd } =
    useActivationCompletion();
  const navigate = useNavigate();
  const [chatData, setchatData] = useState([]);
  const chatDataHistoryRef = useRef([]);
  const isAddRelationProcess = useRef(false);
  const adviceList = useRef([]);
  const isRelationShipAdvice = useRef(false);
  const chatInstructionRelation = useRef({});
  const chatSessionId = useRef("");
  const relationshipFollowupRef = useRef(false);
  const collectedRelationShipFormData = useRef({});
  const [latestInProgressSession, setLatestInProgressSession] = useState(false);
  const [enableCoaching, setEnableCoaching] = useState(true);
  const [lastMsg, setLastMsg] = useState("");
  const [loading, setLoading] = useState(true);
  const [hideChatInput, sethideChatInput] = useState(false);
  const [isChatProgress, setIsChatProgress] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isPrivacyActivated, setIsPrivacyActivated] = useState(false);
  const [contactSelectionRelationAdvice, setcontactSelectionRelationAdvice] =
    useState(null);
  const chatRelationShipAdvice = useRef("");
  const [isElementsMode, setIsElementsMode] = useState(false);
  const [hasSelectedDomain, setHasSelectedDomain] = useState(false);
  const elementsContextRef = useRef({ scope: null, domain: null, level: null });
  const elementsTopicRef = useRef(null);
  // Tracks whether the current session is "in roleplay" — flipped to false
  // when the backend emits a metadata frame with event=roleplay_stopped
  // (per Element Coaching & Roleplay contract).
  const isInRoleplayRef = useRef(false);
  const moduleRefId = useRef("");
  const isPrivacyActivatedRef = useRef(false);
  
  // Elements Assessment mode — tracks whether the current session is an assessment
  const isElementsAssessmentRef = useRef(false);
  const elementsAssessmentTopicRef = useRef(null);

  // Topic Coaching context - persisted from URL params for session continuity
  const topicCoachingRef = useRef(null);
  // ARIS Dialogue session context (module=DIALOGS + instance), set from the
  // dialogue-detail handoff. When present, every turn runs module=DIALOGS with
  // the instance id so the backend builds the session prompt from the program.
  const dialogueRef = useRef(null);
  // Daily Check-In v26.1 (guide §5.1b), handed off from the Journey card with
  // `?checkinSessionId=`. Every turn carries the id; the server decides when
  // the check-in is complete and the thread then carries on as ordinary Talk.
  const checkinSessionId = searchParams?.get("checkinSessionId") || null;
  const checkinRef = useRef({ id: checkinSessionId, completed: false });
  checkinRef.current.id = checkinSessionId;
  // "Talk with Aris" from a Commitment detail (UD v26.5 C7): every turn
  // carries the id and the server frames the conversation with it.
  const commitmentId = searchParams?.get("commitmentId") || null;
  // Mission evolution (Journey v26.3), from the Evolve page's Text choice:
  // /chat?module=MISSION_EVOLUTION&evolutionSessionId=…. Turns run
  // module=MISSION_EVOLUTION; the first has no session and an empty query so
  // Aris speaks first. When Aris proposes an evolved Mission the stream sends
  // `mission_draft_ready` (repeated each turn while it waits — de-duplicated
  // by draft_id) and the chat offers Review. Nothing changes until Save.
  const missionEvolutionId =
    searchParams?.get("module") === "MISSION_EVOLUTION"
      ? searchParams?.get("evolutionSessionId") || null
      : null;
  const missionEvolutionRef = useRef({ id: null, draftId: null });
  missionEvolutionRef.current.id = missionEvolutionId;
  const [missionDraftId, setMissionDraftId] = useState(null);
  const [activeTopicSession, setActiveTopicSession] = useState(null);
  const [elementsIntroConfig, setElementsIntroConfig] = useState(null);
  const lastLoadedRelationIdRef = useRef(null);

  // Chat-specific modals
  const [showEditRelationship, setshowEditRelationship] = useState(false);
  const [showLiveSessionModal, setshowLiveSessionModal] = useState(false);
  const [collectedFormDataRelationship, setcollectedFormDataRelationship] =
    useState({});
  const [chatDataHistory, setchatDataHistory] = useState([]);

  // Normalize relationship payloads coming from different sources to a single shape
  const normalizeAdviceData = useCallback((data) => {
    if (!data || typeof data !== "object") return data;
    const defaults = {
      nickname: null,
      pressure: false,
      relationship_category: undefined,
      relationship_goals: null,
      relationship_length: undefined,
      relationship_status: undefined,
      relationship_type: undefined,
      user1_id: undefined,
      user2_id: undefined,
    };

    const topLevel = {
      relationship_category: data.relationship_category,
      relationship_type: data.relationship_type,
      relationship_length: data.relationship_length,
      relationship_status: data.relationship_status,
      relationship_goals: data.relationship_goals,
      user1_id: data.user1_id,
      user2_id: data.user2_id,
    };

    const related = data.related_data || data.contact_relational_data || {};
    const mergedRelated = {
      ...defaults,
      ...topLevel,
      ...related,
    };

    return {
      ...data,
      related_data: mergedRelated,
      contact_relational_data: data.contact_relational_data || mergedRelated,
      // keep a normalized partner/name for downstream use
      partner_name:
        data.partner_name || data.name || [data.first_name, data.last_name].filter(Boolean).join(" "),
    };
  }, []);

  const pushInData = useCallback(async (data) => {
    // We're already in chat, no need to navigate
    if (showEditRelationship) {
      setshowEditRelationship(false);
      isAddRelationProcess.current = false;
    }
    
    // If in Elements mode and user typed a custom prompt, persist it as topic
    if (isElementsMode && typeof data === "string") {
      elementsTopicRef.current = data;
    }
    
    setIsChatProgress(true);
    let txtToPass;
    
    // Handle Quick Coaching Topic
    if (typeof data === "object" && data?.type === "quickCoachingTopic") {
      // Use conversation_starter as the message text
      txtToPass = data.conversationStarter || data.text;
      
      // Initialize session if needed
      if (!chatSessionId.current) {
        const chatIDRes = await initiateChatSession(txtToPass);
        chatSessionId.current = chatIDRes?.payload?.chat_id;
      }
      
      // Add user message to chat (show the conversation starter to user)
      setchatData((prev) => [...prev, { role: "user", content: txtToPass }]);
      
      // Call API with topic configuration including option_id
      callArisApiWithTopic(txtToPass, {
        topic_id: data.topicId,
        option_id: data.optionId,
        quick: true,
      });
      return;
    }

    // Handle Elements Assessment
    if (typeof data === "object" && data?.type === "elementsAssessment") {
      txtToPass = data.text || "Let's start the assessment";

      // Mark session as Elements Assessment so follow-up messages use the same module
      isElementsAssessmentRef.current = true;
      elementsAssessmentTopicRef.current = data.assessmentTopic;

      // Initialize session if needed
      if (!chatSessionId.current) {
        const chatIDRes = await initiateChatSession(txtToPass);
        chatSessionId.current = chatIDRes?.payload?.chat_id;
      }

      // Add user message to chat
      setchatData((prev) => [...prev, { role: "user", content: txtToPass }]);

      // Call Elements Assessment API
      callElementsAssessment(txtToPass, data.assessmentTopic);
      return;
    }
    
    if (chatSessionId.current === "" || chatSessionId.current === null) {
      await initiateChatSession(
        typeof data === "object" ? data?.text + data?.name : data
      ).then(async (chatIDRres) => {
        chatSessionId.current = chatIDRres?.payload?.chat_id;
        
        if (typeof data === "object" && data !== null && !Array.isArray(data)) {
          if (isAddRelationProcess.current) {
            onAddNewContactWithChat(data, chatDataHistoryRef.current);
          } else if ((data.type === "initiateRelationship")) {
            isRelationShipAdvice.current = true;

            if (data.subType === "directAdvice") {
              txtToPass = data?.text + data?.name;
              if (
                chatSessionId.current !== "" ||
                chatSessionId.current !== null
              ) {
                setchatData((prev) => [
                  ...prev,
                  { role: "user", content: data },
                ]);
                callArisReltionShipApi("");
                isRelationShipAdvice.current = true;
              }
            } else if (data.subType === "addNewContact") {
              isAddRelationProcess.current = true;
            } else if (data.subType === "directAdviceAddNew") {
              txtToPass = data?.text + data?.name;
              if (
                chatSessionId.current !== "" ||
                chatSessionId.current !== null
              ) {
                setchatData((prev) => [
                  ...prev,
                  { role: "user", content: data },
                ]);
                callArisReltionShipApi("");
                isRelationShipAdvice.current = true;
              }
            }
          }
        } else {
          txtToPass = data;
          if (chatSessionId.current !== "" || chatSessionId.current !== null) {
            setchatData((prev) => [...prev, { role: "user", content: data }]);
            if (isElementsAssessmentRef.current) {
              callElementsAssessment(data, elementsAssessmentTopicRef.current);
            } else {
              callArisApi(data);
            }
          }
        }
      });
    } else {
      if (typeof data === "object" && data !== null && !Array.isArray(data)) {
        if (isAddRelationProcess.current) {
          onAddNewContactWithChat(data, chatDataHistoryRef.current);
        } else if ((data.type === "initiateRelationship")) {
          isRelationShipAdvice.current = true;
          if (data.subType === "directAdvice") {
            txtToPass = data?.text + data?.name;
            if (
              chatSessionId.current !== "" ||
              chatSessionId.current !== null
            ) {
              setchatData((prev) => [
                ...prev,
                { role: "user", content: data },
              ]);
              callArisReltionShipApi("");
              isRelationShipAdvice.current = true;
            }
          } else if (data.subType === "addNewContact") {
            isAddRelationProcess.current = true;
          } else if (data.subType === "directAdviceAddNew") {
            txtToPass = data?.text + data?.name;
            if (
              chatSessionId.current !== "" ||
              chatSessionId.current !== null
            ) {
              setchatData((prev) => [
                ...prev,
                { role: "user", content: data },
              ]);
              callArisReltionShipApi("");
              isRelationShipAdvice.current = true;
            }
          }
        }
      } else {
        txtToPass = data;
        if (chatSessionId.current !== "" || chatSessionId.current !== null) {
          setchatData((prev) => [...prev, { role: "user", content: data }]);
          // Use the appropriate API based on the active session mode
          if (isElementsAssessmentRef.current) {
            callElementsAssessment(data, elementsAssessmentTopicRef.current);
          } else if (isRelationShipAdvice.current) {
            callArisReltionShipApi(data);
          } else {
            callArisApi(data);
          }
        }
      }
    }
  }, [showEditRelationship, isElementsMode]);

  // Handle direct advice from URL params
  useEffect(() => {
    if (!relationId) return;
    if (lastLoadedRelationIdRef.current === relationId) return;
    
    const fetchData = async () => {
      try {
        const e = await getRelationshipProfile(relationId);
        adviceList.current = normalizeAdviceData({
          ...e,
          relation_id: e?._id,
          partner_name: e?.partner_name || e?.name || `${e?.first_name || ''} ${e?.last_name || ''}`.trim(),
        });
        
        // Set up relationship advice mode
        isRelationShipAdvice.current = true;
        sethideChatInput(false);
        lastLoadedRelationIdRef.current = relationId;
        if (adviceTitle) chatRelationShipAdvice.current = adviceTitle;
        
        // Create the relationship data object
        const relationshipData = {
          type: "initiateRelationship",
          subType: "directAdviceAddNew",
          text: "I need relationship advice for ",
          name: `${e?.first_name || ''} ${e?.last_name || ''}`.trim(),
          first_name: e?.first_name,
          last_name: e?.last_name,
          profile_pic_url: e?.profile_pic_url,
          contact_relational_data: e?.related_data,
          relation_id: e?._id,
        };

        // Call getRelationshipAdvice to get advice options like in production
        try {
          const adviceResponse = await getRelationshipAdvice(
            e?.related_data?.relationship_category,
            e?.related_data?.relationship_type
          );

          // Create chat session first to ensure we have session_id for API calls
          if (!chatSessionId.current) {
            const chatIDRes = await initiateChatSession(
              relationshipData.text + relationshipData.name
            );
            chatSessionId.current = chatIDRes?.payload?.chat_id;
          }

          // Display the relationship advice options in chat
          setchatData([
            { role: "user", content: relationshipData },
            {
              role: "assistant",
              content: `What kind of advice would you like for your ${e?.related_data?.relationship_type}, ${relationshipData.name}?`,
              options: [...adviceResponse?.advice, "Other (Write your own below)"]
            }
          ]);

        } catch (adviceError) {
          console.error("Error fetching relationship advice options:", adviceError);
          // Set error message like in production
          setcontactSelectionRelationAdvice(
            adviceError?.response?.data?.message || "Failed to load relationship advice options"
          );
          // Fallback: use pushInData approach if getRelationshipAdvice fails
          setTimeout(() => {
            if (typeof pushInData === 'function') {
              pushInData(relationshipData);
            }
          }, 100);
        }
        
      } catch (error) {
        console.error("Error fetching relationship profile:", error);
      }
    }
    fetchData();
  }, [adviceTitle, relationId, normalizeAdviceData]);

  // Clear relationship advice error after 3 seconds
  useEffect(() => {
    if (contactSelectionRelationAdvice) {
      const timeout = setTimeout(() => {
        setcontactSelectionRelationAdvice(null);
      }, 3000);
      return () => clearTimeout(timeout);
    }
  }, [contactSelectionRelationAdvice]);

  // Map query params to Elements intro content and options (JSON-driven)
  const buildElementsIntro = useCallback((params) => {
    if (!params) return null;
    const name = profileContent?.first_name || profileContent?.name || "";
    const domain = (params.get("domain") || "").toLowerCase();
    const level = (params.get("level") || "").toLowerCase();
    const scope = (params.get("scope") || "").toLowerCase();

    const join = (lines) => lines.filter(Boolean).join("\n\n");
    const tpl = (s) => (s ? s.replace(/\{\{name\}\}/g, name) : s);
    const tplArr = (arr) => (Array.isArray(arr) ? arr.map(tpl) : arr);

    if (elementsIntroConfig) {
      if (scope === "this_is_you") {
        const cfg = elementsIntroConfig?.scope?.this_is_you;
        if (cfg) return { content: join(tplArr(cfg.content || [])), options: cfg.options || [] };
      }
      if (domain && elementsIntroConfig?.domains?.[domain]) {
        const d = elementsIntroConfig.domains[domain];
        return { content: join([tpl(d.title), tpl(d.lead), "Select from any of the topics below, or type your own to begin.", d.topicsHeader || ""]), options: d.options || [] };
      }
      if (level && elementsIntroConfig?.levels?.[level]) {
        const l = elementsIntroConfig.levels[level];
        return { content: join([tpl(l.title), tpl(l.lead), "Select from any of the topics below, or type your own to begin.", l.topicsHeader || ""]), options: l.options || [] };
      }
    }

    // Minimal fallback only for this_is_you (no options), if JSON missing
    if (scope === "this_is_you") {
      return {
        content: join([
          `Welcome, ${name}.`,
          "The way you think, feel, lead, and love isn't random. It's a reflection of the Aris Elements that make you uniquely you. This is where insight becomes transformation.",
          "Select from any of the topics below, or type your own to begin.",
        ]),
        options: [],
      };
    }
    return null;
  }, [profileContent, elementsIntroConfig]);

  // Handle elements intro when arriving with params
  useEffect(() => {
    // Accept both "/chat" and "/chat/"
    if (!/\/chat\/?$/.test(location.pathname)) return;
    const hasElements = searchParams?.get("elements") === "1";
    if (!hasElements) return;
    // Persist context immediately and enable Elements mode regardless of intro availability
    setIsElementsMode(true);
    setHasSelectedDomain(true);
    const scope = searchParams?.get("scope");
    const domain = searchParams?.get("domain");
    const level = searchParams?.get("level");
    if (scope || domain || level) {
      elementsContextRef.current = { scope, domain, level };
    }
    // When arriving via the new (i)-sheet topic-pick flow, the dialog has
    // already shown the intro/options to the user and the chat will auto-fire
    // the selected question. Skip rendering the intro greeting and the option
    // pills so the chat opens straight into the conversation.
    const elementAction = searchParams?.get("element_action");
    if (elementAction === "coaching" || elementAction === "roleplay") return;

    // Try to build intro using searchParams
    const intro = buildElementsIntro(searchParams);
    if (intro) {
      setchatData([
        {
          role: "assistant",
          content: intro.content,
          options: intro.options,
        },
      ]);
    }
  }, [location.pathname, searchParams, buildElementsIntro]);

  // Initialize coaching sessions
  useEffect(() => {
    const fetchSessions = async () => {
      try {
        const sessions = await getSessions();
        // getSessions swallows its own errors and returns undefined, and the
        // payload is not always an array — an object shape here threw
        // "payload.some is not a function" on every chat mount.
        const list = Array.isArray(sessions?.payload)
          ? sessions.payload
          : Array.isArray(sessions?.payload?.sessions)
            ? sessions.payload.sessions
            : Array.isArray(sessions?.data)
              ? sessions.data
              : [];
        setLatestInProgressSession(
          list.some((session) => session?.status === "in_progress")
        );
      } catch (error) {
        console.error("Error fetching sessions:", error);
        setLatestInProgressSession(false);
      }
    };
    fetchSessions();
  }, []);

  // Always hide main header on /chat route - we use RelationshipHeader instead
  useLayoutEffect(() => {
    setHeaderContent(false);
  }, [setHeaderContent]);

  // Initialize loading state
  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
      setIsLoading(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  // Load Elements intro config (JSON) with caching
  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const cfg = await fetchElementsIntroConfig();
        if (mounted) setElementsIntroConfig(cfg);
      } catch (_) {
        // Non-fatal: fallback to hardcoded content
      }
    })();
    return () => { mounted = false; };
  }, []);

  // Incognito was removed (product 2026-10-15): neither ?privacy=true nor a stored
  // value turns it on any more, and a value an older build stored is cleared.
  useEffect(() => {
    localStorage.removeItem("chatPrivacyMode");
  }, []);

  // Initialize Topic Coaching context from URL parameters
  // Dialogue handoff: /chat?module=DIALOGS&dialogueId=… (start) or
  // &instanceId=… (continue). A Dialogue is one conversation across text and
  // voice: the chat shows its whole history (voice transcripts included), and
  // when Aris hasn't spoken yet in the current session it sends the `open`
  // event so Aris's first message streams in — no client-side welcome line.
  const dialogueSeededRef = useRef(false);

  // Replace the chat with the Dialogue's full history. Returns the history
  // head so callers can decide whether Aris still has to open the session.
  const loadDialogueHistory = useCallback(async (instanceId) => {
    const history = await getDialogueHistory(instanceId);
    setchatData(toDialogueChatMessages(history.messages));
    if (history.isComplete) sethideChatInput(true);
    return history;
  }, []);

  // Aris opens the session as a streamed first message. If someone else
  // already opened it (another device, a voice call, a parallel open) the
  // stream is just the metadata frame — reload the history instead.
  const openDialogue = useCallback(
    async (instanceId) => {
      setchatData((prev) => [...prev, { role: "assistant", content: "", modality: "TEXT" }]);
      let opened = null;
      let streamError = null;
      let text = "";
      const response = await openDialogueSession(instanceId);
      await parseStreamingResponse(
        response,
        (metadata) => {
          if (metadata?.event === "dialogue_open") opened = metadata.opened;
          if (metadata?.session_id && !chatSessionId.current) {
            chatSessionId.current = metadata.session_id;
          }
        },
        (chunk) => {
          text = chunk.type === "response" ? chunk.content : text + chunk.content;
          setchatData((prev) => {
            const next = [...prev];
            const i = next.findLastIndex((m) => m.role === "assistant");
            if (i !== -1) next[i] = { ...next[i], content: text };
            return next;
          });
        },
        (error) => {
          streamError = error;
        }
      );
      if (streamError) throw streamError;
      if (opened === false || !text) {
        await loadDialogueHistory(instanceId);
      } else {
        setLastMsg(text.trim());
      }
    },
    [loadDialogueHistory]
  );

  useEffect(() => {
    if (dialogueSeededRef.current) return;
    if (searchParams?.get("module") !== "DIALOGS") return;
    dialogueSeededRef.current = true;
    dialogueRef.current = {
      instance_id: searchParams?.get("instanceId") || null,
      title: location.state?.dialogueTitle || null,
    };
    const templateId = searchParams?.get("dialogueId");
    if (!dialogueRef.current.instance_id && !templateId) return;

    let cancelled = false;
    setIsChatProgress(true);
    (async () => {
      try {
        // Continuing by instance: never start again (that would open a
        // second instance). Starting is fast — no AI call on the server.
        let instanceId = dialogueRef.current.instance_id;
        if (!instanceId) {
          const instance = await startDialogue(templateId);
          if (cancelled) return;
          instanceId = instance?.instance_id;
          if (!instanceId) throw new Error("start returned no instance_id");
          dialogueRef.current = {
            instance_id: instanceId,
            title: instance?.title || dialogueRef.current.title,
          };
        }
        const history = await loadDialogueHistory(instanceId);
        if (cancelled) return;
        if (!history.hasOpened && !history.isComplete) {
          await openDialogue(instanceId);
        }
      } catch (e) {
        console.error("Failed to open the dialogue", e);
        if (!cancelled) {
          setchatData((prev) => {
            const msg = {
              role: "assistant",
              content:
                "I couldn't get this dialogue ready just now. Please go back and try again.",
            };
            const last = prev[prev.length - 1];
            // Replace an empty streaming placeholder rather than stacking under it.
            return last?.role === "assistant" && !last.content
              ? [...prev.slice(0, -1), msg]
              : [...prev, msg];
          });
        }
      } finally {
        if (!cancelled) setIsChatProgress(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [searchParams, location.state, loadDialogueHistory, openDialogue]);

  useEffect(() => {
    const topicId = searchParams?.get("topic_id");
    const optionId = searchParams?.get("option_id");
    const isQuick = searchParams?.get("quick") === "true";
    const moduleParam = searchParams?.get("module");
    const topicTitle = searchParams?.get("topic_title");
    const categoryName = searchParams?.get("category_name");
    
    // Set topic coaching context if:
    // 1. Coming from new topic session with topic_id, option_id, quick params
    // 2. Coming from history with module=TOPIC_COACHING
    // 3. Has topic_title in URL (for refresh scenarios)
    if (topicId && optionId && isQuick) {
      topicCoachingRef.current = {
        topic_id: topicId,
        option_id: optionId,
        quick: true,
      };
    } else if (moduleParam === "TOPIC_COACHING" || (topicId && topicTitle)) {
      // Coming from history or refresh - set minimal context to ensure module is used
      topicCoachingRef.current = {
        topic_id: topicId || null,
        option_id: optionId || null,
        quick: true,
      };
    }
    
    // Set active topic session for header display if title available
    if (topicTitle) {
      setActiveTopicSession({
        topicId,
        optionId,
        topicTitle: decodeURIComponent(topicTitle),
        categoryName: categoryName ? decodeURIComponent(categoryName) : null,
      });
    } else if (!topicId && !isQuick && moduleParam !== "TOPIC_COACHING") {
      // Clear active topic session only if definitely not a topic coaching session
      setActiveTopicSession(null);
    }
  }, [searchParams]);

  // Mission evolution: continue this evolution's stored text thread, else
  // start one with an empty query so Aris speaks first.
  const missionStartedRef = useRef(false);
  useEffect(() => {
    if (!missionEvolutionId || missionStartedRef.current) return;
    missionStartedRef.current = true;
    const stored = recallEvolutionChat(missionEvolutionId);
    if (stored) {
      loadChatHistory(stored);
      return;
    }
    setIsChatProgress(true);
    callArisApi("");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [missionEvolutionId]);

  // Auto-start the first turn when arriving from an element-detail handoff
  // (Practice this Scenario / Talk it through with Aris). Fires once per
  // mount so Aris speaks first instead of the user having to type a prompt.
  const elementAutoStartFiredRef = useRef(false);
  // Set when the member arrives from the Element conversation-entry endpoint
  // (PB-12): Aris has opened, and the member's reply — not a synthesized first
  // message — is the conversation's first turn.
  const elementEntryPendingRef = useRef(false);
  useEffect(() => {
    if (elementAutoStartFiredRef.current) return;
    if (!/\/chat\/?$/.test(location.pathname)) return;

    const elementAction = searchParams?.get("element_action");
    if (elementAction !== "coaching" && elementAction !== "roleplay") return;

    // Only auto-start a brand-new session.
    if (chatSessionId.current && chatSessionId.current !== "") return;

    elementAutoStartFiredRef.current = true;

    // Element conversation entry (PB-12). When the member came through
    // `POST /ARIS/v4/discovery/elements/{name}/talk`, Aris has already composed
    // an applied, member-specific opening — so Aris speaks first and the member
    // answers, instead of the client fabricating a first user message.
    //
    // `chat_session_id` is the session the entry endpoint stored that opening
    // against. Adopting it rather than minting a fresh one is what puts the
    // member's reply in the same conversation as the question it answers —
    // history is server-side, so a new session would leave the model reading
    // "the early mornings" as an opening line with no referent.
    const elementOpening = searchParams?.get("element_opening");
    if (elementOpening) {
      const seededSession = searchParams?.get("chat_session_id");
      if (seededSession) chatSessionId.current = seededSession;
      elementEntryPendingRef.current = true;
      setchatData((prev) => [
        ...prev,
        { role: "assistant", content: elementOpening },
      ]);
      return;
    }

    // Initial query selection (per Element Coaching & Roleplay contract):
    //   - roleplay → "begin" (trigger phrase, not user-visible per spec)
    //   - this_is_you → "" (legacy: backend renders the full template)
    //   - element / domain / level → the literal question the user
    //     "asked" by tapping the button. Shown as the user's first
    //     message bubble.
    const scope = (searchParams?.get("scope") || "").toLowerCase();
    let firstQuery;
    if (elementAction === "roleplay") {
      firstQuery = "begin";
    } else if (scope === "this_is_you" || !scope) {
      firstQuery = "";
    } else {
      firstQuery = searchParams?.get("question") || "";
    }
    setIsChatProgress(true);

    if (firstQuery) {
      // Show the user's first turn (or "begin" for roleplay) locally
      // for visual continuity.
      setchatData((prev) => [...prev, { role: "user", content: firstQuery }]);
    }

    // Defer one tick so the elements-intro effect can land first if it runs.
    const t = setTimeout(() => {
      callArisApi(firstQuery);
    }, 0);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, searchParams]);

  // Privacy activation sync
  useEffect(() => {
    isPrivacyActivatedRef.current = isPrivacyActivated;
    
    // Sync privacy state to localStorage immediately when it changes (permanent storage)
    if (isPrivacyActivated) {
      localStorage.setItem("chatPrivacyMode", "true");
    } else {
      localStorage.removeItem("chatPrivacyMode");
    }
  }, [isPrivacyActivated]);

  // Load chat history when navigated from ChatHistory with sessionId param
  useEffect(() => {
    const sessionIdFromUrl = searchParams?.get("sessionId");
    
    if (sessionIdFromUrl) {
      // Load specific chat session when navigated from header ChatHistory
      loadChatHistory(sessionIdFromUrl);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams]);

  // Cleanup chat session when component unmounts (e.g., logo click, browser navigation)
  useEffect(() => {
    return () => {
      // Only end session if there's an active chat session
      if (chatSessionId.current && chatSessionId.current !== "") {
        // Determine module based on current chat context
        let module = "COACHING"; // default
        if (missionEvolutionRef.current.id) {
          module = "MISSION_EVOLUTION";
        } else if (dialogueRef.current) {
          module = "DIALOGS";
        } else if (topicCoachingRef.current) {
          module = "TOPIC_COACHING";
        } else if (isRelationShipAdvice.current) {
          module = "RELATIONSHIPS";
        } else if (isElementsMode) {
          module = "ELEMENTS";
        }
        
        onChatEnd(chatSessionId.current, profileContent?._id, null, module)
          .then(() => {
            // Clear session data
            chatSessionId.current = "";
          })
          .catch((error) => {
            console.error("Error ending chat session on unmount:", error);
          });
      }

      // Leaving before the server completed the check-in pauses it
      // recoverably, so Journey offers Continue. Never a completion.
      const checkin = checkinRef.current;
      if (checkin.id && !checkin.completed) {
        pauseCheckIn(checkin.id, "USER_EXIT", true).catch((error) => {
          console.error("Error pausing the check-in on unmount:", error);
        });
      }

      // The conversation is over, which is when activation completion is worth
      // asking about — the closing turn has been and gone. No-ops unless
      // activation was pending; the write is to localStorage, so it lands even
      // though this screen is already unmounting.
      onActivationConversationEnd();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Empty dependency array - only run on unmount



  const buildElementsIntroConfig = useCallback(async () => {
    try {
      const config = await fetchElementsIntroConfig();
      setElementsIntroConfig(config);
      return config;
    } catch (error) {
      console.error("Failed to fetch elements intro config:", error);
      return null;
    }
  }, []);

  const onAddNewContactWithChat = (data, history) => {
    if (data?.length === 0) {
      return;
    }
    const tmp = {
      name: data?.first_name + " " + data?.last_name,
      history: history,
      relationship_category: data?.relationship_category,
      relationship_goals: data?.relationship_goals,
      relationship_length: data?.relationship_length,
      relationship_status: data?.relationship_status,
      relationship_type: data?.relationship_type,
      user1_id: data?.user1_id,
      user2_id: data?.user2_id,
      nickname: data?.nickname,
      pressure: data?.pressure,
    };
    chatCreateRelationShip(tmp).then((res) => {
      if (res?.status === "success") {
        setchatData((prev) => [
          ...prev,
          {
            role: "assistant",
            content: res?.query || "something went wrong !!",
          },
        ]);
      }
    });
  };


  // Handle automatic input processing from dashboard navigation
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const inputParam = urlParams.get("input");
    const dataParam = urlParams.get("data");
    
    if (inputParam) {
      // Simple text input from dashboard
      const decodedInput = decodeURIComponent(inputParam);
      // Clean up URL params
      urlParams.delete("input");
      const cleanUrl = urlParams.toString();
      window.history.replaceState({}, "", `/chat${cleanUrl ? `?${cleanUrl}` : ""}`);
      
      // Automatically start conversation with the input
      setTimeout(() => {
        pushInData(decodedInput);
      }, 100); // Small delay to ensure component is ready
    } else if (dataParam) {
      // Complex object data from dashboard
      try {
        const decodedData = JSON.parse(decodeURIComponent(dataParam));
        // Clean up URL params
        urlParams.delete("data");
        const cleanUrl = urlParams.toString();
        window.history.replaceState({}, "", `/chat${cleanUrl ? `?${cleanUrl}` : ""}`);
        
        // Automatically start conversation with the data
        setTimeout(() => {
          pushInData(decodedData);
        }, 100);
      } catch (error) {
        console.error("Failed to parse data param:", error);
      }
    }
  }, [pushInData]); // Run when pushInData changes

  // Handle elements intro when arriving with params (like production code)
  useEffect(() => {
    // Accept both "/chat" and "/chat/"
    if (!/\/chat\/?$/.test(location.pathname)) return;
    if (!searchParams) return;
    const hasElements = searchParams.get("elements") === "1";
    if (!hasElements) return;
    
    // Persist context immediately and enable Elements mode regardless of intro availability
    elementsContextRef.current = {
      scope: (searchParams.get("scope") || "").toLowerCase() || null,
      domain: (searchParams.get("domain") || "").toLowerCase() || null,
      level: (searchParams.get("level") || "").toLowerCase() || null,
    };
    setIsElementsMode(true);
    setHasSelectedDomain(true);
    sethideChatInput(false);

    // Skip the intro greeting/options when arriving via the new (i)-sheet
    // topic-pick flow — the dialog already showed them and the chat will
    // auto-fire the selected question.
    const elementAction = searchParams.get("element_action");
    if (elementAction === "coaching" || elementAction === "roleplay") return;

    const intro = buildElementsIntro(searchParams);
    if (intro) {
      setchatData([
        {
          role: "assistant",
          content: intro.content,
          options: intro.options,
        },
      ]);
    }
  }, [location.pathname, searchParams, buildElementsIntro]);

  const callArisApi = async (data) => {
    try {
      setchatData((prev) => [...prev, { role: "assistant", content: "" }]);
      
      // Check if this is a Topic Coaching session (from URL params)
      const isTopicCoaching = !!topicCoachingRef.current;

      // Determine if this is an Elements chat
      const urlParams = new URLSearchParams(window.location.search || "");
      const fromElementsUrl = urlParams.get("elements") === "1";
      const hasCtx = !!(elementsContextRef.current?.scope || elementsContextRef.current?.domain || elementsContextRef.current?.level);
      const isElementsChat = (isElementsMode || fromElementsUrl || hasCtx);

      // Element-action handoff (see Element Coaching & Roleplay contract).
      // Per contract: only the FIRST turn carries event=roleplay_start /
      // elements_chat_coaching with metadata. Continuation turns revert to
      // event=send_message and the backend retrieves prompt/scope context
      // from session_id.
      const elementAction = urlParams.get("element_action");
      const isRoleplay = elementAction === "roleplay";
      // After a PB-12 entry the member's reply is the first turn even though
      // `handleSendMessage` has already minted a session id — Aris spoke
      // first, so nothing has been sent yet. Without this the scope=element
      // metadata (topic, prompt_variant, level) is dropped and the backend
      // reads the reply as a continuation of open coaching.
      const isFirstTurn =
        !chatSessionId.current || elementEntryPendingRef.current;

      let metadata = undefined;
      let scope = (urlParams.get("scope") || elementsContextRef.current?.scope || "").toLowerCase();
      let domain = (urlParams.get("domain") || elementsContextRef.current?.domain || null);
      let level = (urlParams.get("level") || elementsContextRef.current?.level || null);
      // Scope inference fallback for older entry points that only set
      // domain/level. New entry points always set scope explicitly.
      if (!scope) {
        if (domain) scope = "domain";
        else if (level) scope = "level";
        else scope = "this_is_you";
      }
      const urlTopic = urlParams.get("topic");
      const promptVariant = urlParams.get("prompt_variant") || null;
      const conversationTopic = urlParams.get("conversation_topic") || null;
      const question = urlParams.get("question") || null;

      if (isFirstTurn && isRoleplay) {
        metadata = {
          topic: urlTopic || elementsTopicRef.current || data,
          domain: domain || null,
          level: level || null,
          situation: urlParams.get("situation") || null,
          reason: urlParams.get("reason") || null,
          relationship: urlParams.get("relationship") || null,
        };
        isInRoleplayRef.current = true;
      } else if (isFirstTurn && isElementsChat) {
        // Build per-scope metadata per contract:
        //  scope=element → topic + prompt_variant (+ optional question)
        //  scope=domain  → topic + domain + conversation_topic + question
        //  scope=level   → topic + level  + conversation_topic + question
        //  scope=this_is_you → topic only (legacy)
        const baseMeta = {
          topic: urlTopic || elementsTopicRef.current || data,
          scope,
        };
        if (scope === "element") {
          metadata = {
            ...baseMeta,
            prompt_variant: promptVariant || "new",
            ...(question ? { question } : {}),
          };
        } else if (scope === "domain") {
          metadata = {
            ...baseMeta,
            domain: domain || null,
            conversation_topic: conversationTopic || "open",
            ...(question ? { question } : {}),
          };
        } else if (scope === "level") {
          metadata = {
            ...baseMeta,
            level: level || null,
            conversation_topic: conversationTopic || "open",
            ...(question ? { question } : {}),
          };
        } else {
          metadata = baseMeta; // this_is_you / legacy
        }
      }

      const eventName = !isFirstTurn
        ? "send_message"
        : (isRoleplay
            ? "roleplay_start"
            : (isElementsChat ? "elements_chat_coaching" : "send_message"));

      // Spent — every later turn is a continuation.
      elementEntryPendingRef.current = false;

      const response = await chatArisApi(
        profileContent?._id,
        data,
        chatSessionId.current,
        missionEvolutionRef.current.id
          ? "MISSION_EVOLUTION"
          : dialogueRef.current
            ? "DIALOGS"
            : "COACHING",
        true,
        {
          is_private: isPrivacyActivatedRef.current,
          ...(missionEvolutionRef.current.id
            ? { evolution_session_id: missionEvolutionRef.current.id }
            : {}),
          ...(dialogueRef.current?.instance_id
            ? { instance_id: dialogueRef.current.instance_id }
            : {}),
          ...(checkinRef.current.id
            ? { checkin_session_id: checkinRef.current.id }
            : {}),
          ...(commitmentId ? { commitment_id: commitmentId } : {}),
        },
        missionEvolutionRef.current.id
          ? chatSessionId.current
            ? "send_message"
            : "start_message"
          : eventName,
        metadata,
        isTopicCoaching ? topicCoachingRef.current : undefined // Pass topic config for session continuity
      );

      let assistantMessage = "";
      let sessionId = chatSessionId.current;

      // Handle streaming response
      await parseStreamingResponse(
        response,
        // onMetadata callback
        (metadata) => {
          if (metadata.session_id && !sessionId) {
            sessionId = metadata.session_id;
            chatSessionId.current = metadata.session_id;
            // Persist for activation so a reload resumes the same transcript.
            // No-ops unless the member is mid-activation.
            rememberActivationSession(metadata.session_id);
            // Opening Text again for this evolution continues this thread.
            rememberEvolutionChat(missionEvolutionRef.current.id, metadata.session_id);
          }
          if (
            metadata?.event === "mission_draft_ready" &&
            metadata.draft_id &&
            metadata.draft_id !== missionEvolutionRef.current.draftId
          ) {
            missionEvolutionRef.current.draftId = metadata.draft_id;
            trackEvent(MISSION_EVENT.DRAFT_GENERATED, { mode: "TEXT" });
            setMissionDraftId(metadata.draft_id);
          }
          // Per contract: backend emits a metadata frame with
          // event=roleplay_stopped after detecting a stop intent. Drop
          // the in-roleplay flag so future turns send plain send_message.
          if (metadata?.event === "roleplay_stopped") {
            isInRoleplayRef.current = false;
          }
          // At most once, on the turn the server completed today's check-in.
          // The member may still be typing: no navigation, no close.
          if (
            metadata?.checkin?.state === "COMPLETED" &&
            !checkinRef.current.completed
          ) {
            checkinRef.current.completed = true;
            showSuccessToast("Today's check-in is complete.");
          }
        },
        // onChunk callback
        (chunk) => {
          // The final `response` frame carries the whole message, not a
          // delta: replace rather than append, or the reply doubles.
          assistantMessage =
            chunk.type === "response" ? chunk.content : assistantMessage + chunk.content;
          // Update the UI with streaming content
          setchatData((prev) => {
            const newData = [...prev];
            const assistantIndex = newData.findLastIndex(
              (item) => item.role === "assistant"
            );
            if (assistantIndex !== -1) {
              newData[assistantIndex].content = assistantMessage;
            }
            return newData;
          });
        },
        // onError callback
        (error) => {
          console.error('Streaming error:', error);
          throw error;
        }
      );

      const finalMessage = assistantMessage?.trim();
      setLastMsg(finalMessage);
    } catch (error) {
      console.error("Error in callArisApi:", error);
      setchatData((prev) => {
        const newData = [...prev];
        if (newData.length > 0) {
          newData[newData.length - 1] = {
            ...newData[newData.length - 1],
            content: "I apologize, but I encountered an error. Please try again."
          };
        }
        return newData;
      });
    } finally {
      setIsChatProgress(false);
    }
  };

  // API call for Quick Coaching Topics with topic_id and quick flag
  const callArisApiWithTopic = async (data, topicConfig) => {
    try {
      setchatData((prev) => [...prev, { role: "assistant", content: "" }]);
      
      const response = await chatArisApi(
        profileContent?._id,
        data,
        chatSessionId.current,
        "COACHING",
        true,
        { is_private: isPrivacyActivatedRef.current },
        "send_message", // event will be overridden to "topic" by chatArisApi
        undefined,
        topicConfig // { topic_id, quick: true }
      );

      let assistantMessage = "";
      let sessionId = chatSessionId.current;

      // Handle streaming response
      await parseStreamingResponse(
        response,
        // onMetadata callback
        (metadata) => {
          if (metadata.session_id && !sessionId) {
            sessionId = metadata.session_id;
            chatSessionId.current = metadata.session_id;
            // Persist for activation so a reload resumes the same transcript.
            // No-ops unless the member is mid-activation.
            rememberActivationSession(metadata.session_id);
          }
        },
        // onChunk callback
        (chunk) => {
          // The final `response` frame carries the whole message, not a
          // delta: replace rather than append, or the reply doubles.
          assistantMessage =
            chunk.type === "response" ? chunk.content : assistantMessage + chunk.content;
          // Update the UI with streaming content
          setchatData((prev) => {
            const newData = [...prev];
            const assistantIndex = newData.findLastIndex(
              (item) => item.role === "assistant"
            );
            if (assistantIndex !== -1) {
              newData[assistantIndex].content = assistantMessage;
            }
            return newData;
          });
        },
        // onError callback
        (error) => {
          console.error('Streaming error:', error);
          throw error;
        }
      );
      
      const finalMessage = assistantMessage?.trim();
      setLastMsg(finalMessage);
    } catch (error) {
      console.error("Error in callArisApiWithTopic:", error);
      setchatData((prev) => {
        const newData = [...prev];
        if (newData.length > 0) {
          newData[newData.length - 1] = {
            ...newData[newData.length - 1],
            content: "I apologize, but I encountered an error. Please try again."
          };
        }
        return newData;
      });
    } finally {
      setIsChatProgress(false);
    }
  };

  // Elements Assessment session state (session_id + conversation_id from backend)
  const elementsAssessmentRef = useRef({ sessionId: null, conversationId: null });

  // API call for Elements Assessment with module: ELEMENTS_ASSESSMENT
  const callElementsAssessment = async (query, topic) => {
    try {
      setchatData((prev) => [...prev, { role: "assistant", content: "" }]);

      const response = await chatElementsAssessmentApi(
        profileContent?._id,
        query,
        elementsAssessmentRef.current.sessionId,
        elementsAssessmentRef.current.conversationId,
        topic,
        true, // stream
      );

      let assistantMessage = "";

      await parseStreamingResponse(
        response,
        // onMetadata callback
        (metadata) => {
          if (metadata.session_id) {
            elementsAssessmentRef.current.sessionId = metadata.session_id;
          }
          if (metadata.conversation_id) {
            elementsAssessmentRef.current.conversationId = metadata.conversation_id;
          }
        },
        // onChunk callback
        (chunk) => {
          // The final `response` frame carries the whole message, not a
          // delta: replace rather than append, or the reply doubles.
          assistantMessage =
            chunk.type === "response" ? chunk.content : assistantMessage + chunk.content;
          setchatData((prev) => {
            const newData = [...prev];
            const assistantIndex = newData.findLastIndex(
              (item) => item.role === "assistant"
            );
            if (assistantIndex !== -1) {
              newData[assistantIndex].content = assistantMessage;
            }
            return newData;
          });
        },
        // onError callback
        (error) => {
          console.error("Elements Assessment streaming error:", error);
          throw error;
        }
      );

      const finalMessage = assistantMessage?.trim();
      setLastMsg(finalMessage);
    } catch (error) {
      console.error("Error in callElementsAssessment:", error);
      setchatData((prev) => {
        const newData = [...prev];
        if (newData.length > 0) {
          newData[newData.length - 1] = {
            ...newData[newData.length - 1],
            content: "I apologize, but I encountered an error. Please try again.",
          };
        }
        return newData;
      });
    } finally {
      setIsChatProgress(false);
    }
  };

  const callArisReltionShipApi = async (data) => {
    try {
      setchatData((prev) => [...prev, { role: "assistant", content: "" }]);
      // Build unified payload for relationship advice v2
      const partnerId = adviceList.current?.user1_id === profileContent?._id
        ? adviceList.current?.user2_id
        : adviceList.current?.user1_id;
      
      const partnerName = adviceList.current?.partner_name || 
                         adviceList.current?.name || 
                         `${adviceList.current?.first_name || ''} ${adviceList.current?.last_name || ''}`.trim() ||
                         "Unknown";
      
      const relationshipPayload = {
        user_id: profileContent?._id,
        partner_id: partnerId,
        partner_name: partnerName,
        session_id: chatSessionId.current,
        relationship_category:
          adviceList.current?.related_data?.relationship_category ||
          adviceList.current?.contact_relational_data?.relationship_category,
        related_us:
          adviceList.current?.related_data?.relationship_type ||
          adviceList.current?.contact_relational_data?.relationship_type,
        topic: chatRelationShipAdvice.current || "",
        u1_Pstatus: relationId
          ? adviceList.current?.related_data?.u1_status
          : adviceList.current?.contact_relational_data?.u1_status,
        u2_Pstatus: relationId
          ? adviceList.current?.related_data?.u2_status
          : adviceList.current?.contact_relational_data?.u2_status,
        relationship_id: adviceList.current?.relation_id || relationId,
        is_private: isPrivacyActivatedRef.current,
        ...(relationshipFollowupRef.current ? { followup_query: true } : {}),
      };

      const response = await chatArisApiRelationShip(
        profileContent?._id,
        data,
        chatSessionId.current,
        relationshipPayload,
        true,
        "relationship_advice_v2"
      );

      let assistantMessage = "";
      let sessionId = chatSessionId.current;

      await parseStreamingResponse(
        response,
        // onMetadata
        (metadata) => {
          if (metadata.session_id && !sessionId) {
            sessionId = metadata.session_id;
            chatSessionId.current = metadata.session_id;
          }
        },
        // onChunk
        (chunk) => {
          // The final `response` frame carries the whole message, not a
          // delta: replace rather than append, or the reply doubles.
          assistantMessage =
            chunk.type === "response" ? chunk.content : assistantMessage + chunk.content;
          setchatData((prev) => {
            const newData = [...prev];
            const assistantIndex = newData.findLastIndex((item) => item.role === "assistant");
            if (assistantIndex !== -1) {
              newData[assistantIndex].content = assistantMessage;
            }
            return newData;
          });
        },
        // onError
        (error) => {
          console.error("Streaming error:", error);
          throw error;
        }
      );

      const finalMessage = (assistantMessage || "").trim();
      if (finalMessage) {
        setLastMsg(finalMessage);
        // Subsequent calls should set followup_query=true
        relationshipFollowupRef.current = true;
      }
    } catch (error) {
      console.error("Error in callArisReltionShipApi:", error);
      setchatData((prev) => {
        const newData = [...prev];
        if (newData.length > 0) {
          newData[newData.length - 1] = {
            ...newData[newData.length - 1],
            content: "I apologize, but I encountered an error. Please try again."
          };
        }
        return newData;
      });
    } finally {
      setIsChatProgress(false);
    }
  };

  const onOptionSelected = (e) => {
    if (isElementsMode) {
      const text = e?.text || e;
      if (text === "Other (Type your own below)" || text === "Other (Write your own below)") {
        sethideChatInput(false);
        return;
      }
      if (e?.context) {
        if (e.context.domain || e.context.level) {
          elementsContextRef.current = {
            scope: e.context.scope || null,
            domain: e.context.domain || null,
            level: e.context.level || null,
          };
        }
        return;
      }
      elementsTopicRef.current = text;
      pushInData(text);
      return;
    }
    if (e?.text === "Other (Write your own below)") {
      sethideChatInput(false);
    } else {
      chatRelationShipAdvice.current = e?.text;
      callArisReltionShipApi(e?.text, e?.text || "");
    }
  };

  const onAddRealtionClose = (val) => {
    setshowEditRelationship(val);
  };

  const onAddedRelationShip = (data) => {
    pushInData(data);
    setshowEditRelationship(false);
  };

  const loadChatHistory = async (sessionId) => {
    try {
      const res = await getChatHistory(sessionId);
      const chatHistory = res?.data?.[0] || [];
      const module = chatHistory.module;
      
      // If this is a relationship advice session, restore the relationship context
      if (module === "RELATIONSHIPS" || module === "RELATIONSHIP_ADVICE") {
        isRelationShipAdvice.current = true;
        const meta = chatHistory?.metadata || {};
        const relRaw = meta?.relationship_data || {};
        
        // Normalize keys expected downstream
        const normalizedRel = {
          ...relRaw,
          // Ensure presence of required keys with correct naming
          relationship_category: relRaw.relationship_category ?? meta.relationship_category,
          relationship_type: relRaw.relationship_type ?? relRaw.related_us ?? meta.related_us,
          u1_status: relRaw.u1_status ?? meta.u1_Pstatus,
          u2_status: relRaw.u2_status ?? meta.u2_Pstatus,
        };
        
        adviceList.current = {
          contact_relational_data: normalizedRel,
          topic: meta.topic,
          partner_name: meta.partner_name,
          name: meta.name,
          // Preserve relationship id so API payload includes it
          relation_id: meta.relationship_id,
        };
        
        chatRelationShipAdvice.current = chatHistory?.metadata?.topic;
      }
      
      // Convert messages to the format expected by the UI
      const chatHistoryMessages = await convertMessages(chatHistory?.messages, module);
      chatSessionId.current = sessionId;
      setchatData(chatHistoryMessages);
      chatDataHistoryRef.current = chatHistoryMessages;
      moduleRefId.current = module;
    } catch (error) {
      console.error("Error loading chat history:", error);
    }
  };

  const loadLatestChatHistory = async () => {
    const res = await getLatestChatHistory();
    const chatHistory = await convertMessages(res?.data?.messages, res?.data?.module);
    chatSessionId.current = res?.data?.session_id;
    setchatData(chatHistory);
    chatDataHistoryRef.current = chatHistory;
  };

  const handleRouteToSubscription = () => {
    navigate("/pricing");
  };

  const onChatBackButtonClick = () => {
    // Handle back navigation from chat - end session first if active
    // Determine module based on current chat context
    let module = "COACHING"; // default
    if (missionEvolutionRef.current.id) {
      module = "MISSION_EVOLUTION";
    } else if (dialogueRef.current) {
      module = "DIALOGS";
    } else if (isRelationShipAdvice.current) {
      module = "RELATIONSHIPS";
    } else if (isElementsMode) {
      module = "ELEMENTS";
    }

    // Back returns to wherever the member came from (dialogue detail, Explore,
    // history…); /dashboard only when the chat was the entry point.
    const returnToOrigin = () => {
      if (window.history.length > 1) {
        navigate(-1);
      } else {
        navigate("/dashboard");
      }
    };

    // No session yet (member left before the first turn): nothing to end.
    const endCall = chatSessionId.current
      ? onChatEnd(chatSessionId.current, profileContent?._id, null, module)
      : Promise.resolve();
    // Time-box the end call — leaving must never hang on a slow summarize.
    const timeBoxed = Promise.race([
      endCall.catch(() => null),
      new Promise((resolve) => setTimeout(resolve, 4000)),
    ]);

    timeBoxed
      .then((res) => {
        chatSessionId.current = "";
        isAddRelationProcess.current = false;
      })
      .finally(() => {
        setIsLoading(true);
        try {
          const params = new URLSearchParams(window.location.search || "");
          if (params.get("elements") === "1") {
            navigate("/elements");
          } else {
            returnToOrigin();
          }
        } catch (_) {
          returnToOrigin();
        }
        setchatData([]);
        setchatDataHistory([]);
        setIsChatProgress(false);

        chatSessionId.current = "";
        isAddRelationProcess.current = false;
        chatDataHistoryRef.current = "";
        chatRelationShipAdvice.current = "";
        isRelationShipAdvice.current = false;
        relationshipFollowupRef.current = false;
      });
  };

  return (
    <>
      <RelationshipHeader
        onBackClick={onChatBackButtonClick}
        activeTopicSession={activeTopicSession}
      />
      <SessionSelection
        showLiveSessionModal={showLiveSessionModal}
        setshowLiveSessionModal={setshowLiveSessionModal}
      />
      {loading ? (
        <DefaultLoader />
      ) : (
        <>
          <div
            className={
              "relationship-hero-container" +
              (chatData.length !== 0 ? " align-down" : "")
            }
          >
            <div
              className={`relationship-parent-scroll-container ${
                (loading || isLoading) && "loading"
              } ${
                !(loading || isLoading) &&
                chatData.length === 0 &&
                "initial-chat"
              }`}
            >
              <div
                className={`relationship-container ${
                  chatData.length === 0 && "relation-chat-cont-initial"
                }`}
              >
                {missionDraftId && (
                  <div className="chat-mission-review" role="status">
                    <span className="chat-mission-review__text">
                      Your evolved Mission is ready. Nothing changes until you save it.
                    </span>
                    <button
                      type="button"
                      className="chat-mission-review__btn"
                      onClick={() => navigate(missionRoutes.review(missionDraftId))}
                    >
                      Review your Mission
                    </button>
                  </div>
                )}
                <RelationShipChat
                  onEnterData={pushInData}
                  chatData={chatData}
                  chatSessionId={chatSessionId}
                  onOptionSelected={onOptionSelected}
                  lastQuestID={lastMsg}
                  hideChatInput={hideChatInput}
                  loadLatestChatHistory={loadLatestChatHistory}
                  isChatProgress={isChatProgress}
                  iselements={isElementsMode}
                  isAiLoading={
                    chatData &&
                    chatData[chatData?.length - 1]?.content === ""
                  }
                  isChatLoading={
                    chatData &&
                    chatData[chatData?.length - 1]?.content === ""
                  }
                  hasSelectedDomain={hasSelectedDomain}
                  isPrivacyActivated={isPrivacyActivated}
                  setIsPrivacyActivated={setIsPrivacyActivated}
                  chatPlaceholder={
                    checkinSessionId ? "How are you doing?" : undefined
                  }
                  contactSelectionRelationAdvice={contactSelectionRelationAdvice}
                />
              </div>
            </div>
          </div>
          <Tooltip
            id="tooltip-anchor"
            place={screenWidth <= 488 ? "top-end" : "top"}
            border={"2px solid #D9D9D9"}
            style={{
              backgroundColor: "#FFFFFF",
              borderRadius: "8px",
              color: "#000000",
              zIndex: 999999,
            }}
            clickable
          >
            <p
              style={{
                textAlign: "center",
                fontWeight: 600,
                fontSize: "14px",
                marginBottom: "0.25rem",
                cursor: "default",
                marginTop: 0,
              }}
            >
              Your ARIS Dialogues minutes <br />
              have expired. Please add <br />
              more to continue
            </p>
            <p
              style={{
                textAlign: "center",
                fontWeight: 400,
                fontSize: "12px",
                lineHeight: "14.4px",
                color: "#4674FE",
                cursor: "pointer",
                margin: 0,
              }}
              onClick={handleRouteToSubscription}
            >
              Buy Minutes
            </p>
          </Tooltip>
        </>
      )}
    </>
  );
}

export default ChatInterface;
